import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input, numberAttribute} from '@angular/core'
import {IconDefinition, SizeProp} from '@fortawesome/fontawesome-svg-core'
import {Observable} from 'rxjs'

type BgIntensityOptions = '0' | '10' | '20' | '30' | '50' | 'ghost'

@Component({
  selector: 'cft-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconButtonComponent {
  icon = input.required<IconDefinition>()
  iconSize = input<SizeProp>('lg')
  /** Value must be color understood by CSS, e.g. "white", "#112233", ... */
  iconColor = input<string>()

  title = input<string>()
  ariaLabel = input<string>()
  outlined = input(false, {transform: booleanAttribute})
  isLoading$ = input<Observable<boolean> | null | undefined>(null)

  //TODO ask marco if the shadow should be a part of the button
  shadow = input(false, {transform: booleanAttribute})

  /** width and height in px */
  dimension = input(44, {transform: numberAttribute})

  bgIntensity = input<BgIntensityOptions | undefined>(undefined)
  protected _bgIntensity = computed<BgIntensityOptions>(() => {
    const intensity = this.bgIntensity()
    if (intensity) {
      return intensity
    } else {
      return '10'
    }
  })
}
